/*
(C) 2022, 2024 EDISOFT


System : ESA Datalabs

File Name : sepp_ui/src/global/settings.ts

Author : EDISOFT, CGI

Creation Date : 2022-05-10

This file is subject to the terms and conditions defined in 'LICENSE.txt',
which is part of this source code package.
No part of the package, including this file, may be copied, modified, propagated,
or distributed except according to the terms contained in 'LICENSE.txt'.
*/

/**
 * EDL Settings Management
 */
class Settings {
  advancedUi: boolean = false;

  constructor() {
    const stored = localStorage.getItem("edlSettings");
    if (stored) {
      const data = JSON.parse(stored);
      // NOTE: we currently don't have concerns in loading potentially
      // tampered user data, but that might change in the future, be aware.
      for (const k of Object.keys(data)) {
        this[k] = data[k];
      }
      console.debug('settings loaded');
    } else {
      this.store();
    }
  }

  apply() {
    const cl = document.body.classList;
    if (this.advancedUi) {
      cl.add('advanced-ui');
    } else {
      cl.remove('advanced-ui');
    }
  }

  store() {
    const data = JSON.stringify(Object(this));
    localStorage.setItem('edlSettings', data);
  }

  /**
   * Notify of settings changes through the edlSettingsUpdated event
   */
  notifyChange() {
    console.log('settings updated', Object(this));
    this.apply();
    this.store();
    window.dispatchEvent(new CustomEvent('edlSettingsUpdated', {detail: this}));
  }
}

export const settings = new Settings();

const w = window as any;
w.edlSettings = settings;
